import React from 'react'
import ReactDOM from 'react-dom'
import './resources/assets/scss/index.scss'
import App from './screens/app/App'
import './utils/translation/i18n'
import './utils/translation/yup'
import * as serviceWorker from './utils/serviceWorker'

ReactDOM.render(<App />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
